module.exports = __webpack_public_path__ + "fonts/sam-icons.685a385.ttf";